module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.estimate) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [(_vm.hasEstimate) ? _c('div', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.getEstimateScore(_vm.estimate.paperEstimates)))]) : _c('div', {
    staticClass: "no-score"
  }, [_vm._v("暂无估分")]), _vm._v(" "), _c('div', {
    staticClass: "header-desc"
  }, [_vm._v("我的总分")])]), _vm._v(" "), _c('div', {
    staticClass: "personal-info"
  }, [_c('div', {
    staticClass: "rank"
  }, [_c('div', {
    staticClass: "rank-place"
  }, [_vm._v(_vm._s(_vm.hasEstimate ? _vm.estimate.rank : '— —'))]), _vm._v(" "), _c('div', {
    staticClass: "info-name"
  }, [_vm._v("全省排名")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "beat"
  }, [_c('div', {
    staticClass: "rate"
  }, [(_vm.hasEstimate) ? _c('span', [_vm._v(_vm._s((100 * _vm.estimate.beatRate).toFixed(0)) + "%")]) : _c('span', [_vm._v("— —")])]), _vm._v(" "), _c('div', {
    staticClass: "info-name"
  }, [_vm._v("击败的考生")])])]), _vm._v(" "), _c('div', {
    staticClass: "paper-list"
  }, _vm._l((_vm.estimate.paperEstimates), function(paper, index) {
    return _c('div', {
      key: index,
      staticClass: "paper-item"
    }, [_c('div', {
      staticClass: "paper-content"
    }, [_c('span', [_vm._v(_vm._s(paper.courseName) + "\n          "), (paper.categoryName) ? _c('span', {
      staticClass: "paper-name"
    }, [_vm._v("(" + _vm._s(paper.categoryName) + ")")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "paper-enter"
    }, [(paper.status === 1) ? _c('a', {
      staticClass: "paper-done",
      on: {
        "click": function($event) {
          return _vm.enterPaper(paper.paperId)
        }
      }
    }, [_vm._v(_vm._s(_vm.getPaperScore(paper)) + "分")]) : _vm._e(), _vm._v(" "), (paper.status === 0) ? _c('span', [(paper.openingTime === 0) ? _c('span', {
      staticClass: "disabled"
    }, [_vm._v("即将开始")]) : _c('count-down', {
      attrs: {
        "deadline": paper.openingTime,
        "paperId": paper.paperId
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "icon-right"
    })])])])
  }), 0)]) : _c('div', [_c('Loading')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b318a136"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Personal.vue
// module id = 476
// module chunks = 1